module.exports = __webpack_public_path__ + "static/media/notes.52801d43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/notes.jpg
// module id = 107
// module chunks = 0